import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';

export interface SelectedOrderItemsState {
  selectedOrderItemIds: string[];
}

const initialState: SelectedOrderItemsState = {
  selectedOrderItemIds: [],
};

export const selectedOrderItemsSlice = createSlice({
  name: 'selectedOrderItemsSlice',
  initialState,
  reducers: {
    setSelectedOrderItems: (state, action: PayloadAction<string[]>) => {
      state.selectedOrderItemIds = action.payload;
    },
    addSelectedOrderItem: (state, action: PayloadAction<string>) => {
      if (!state.selectedOrderItemIds.includes(action.payload)) {
        state.selectedOrderItemIds.push(action.payload);
      }
    },
    removeSelectedOrderItem: (state, action: PayloadAction<string>) => {
      state.selectedOrderItemIds = state.selectedOrderItemIds.filter(
        (id) => id !== action.payload
      );
    },
    toggleSelectedOrderItem: (state, action: PayloadAction<string>) => {
      const orderItemId = action.payload;
      const index = state.selectedOrderItemIds.indexOf(orderItemId);
      if (index === -1) {
        state.selectedOrderItemIds.push(orderItemId);
      } else {
        state.selectedOrderItemIds.splice(index, 1);
      }
    },
    clearSelectedOrderItems: (state) => {
      state.selectedOrderItemIds = [];
    },
  },
});

export const {
  setSelectedOrderItems,
  addSelectedOrderItem,
  removeSelectedOrderItem,
  toggleSelectedOrderItem,
  clearSelectedOrderItems,
} = selectedOrderItemsSlice.actions;

// Selectors
export const selectSelectedOrderItemIds = (state: RootState) =>
  state.shipping.selectedOrderItems.selectedOrderItemIds;

export default selectedOrderItemsSlice.reducer;
